// @ts-nocheck
import * as React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import SVG from 'react-inlinesvg'
import { withRouter } from 'react-router-dom'
import MomentLocaleUtils, {
  formatDate,
  parseDate,
} from "react-day-picker/moment";
import moment from 'moment'
import { withTranslation } from 'react-i18next'
import FormatText from '../../helpers/FormatText'
// @ts-ignore
import ICON_CALENDAR from "../../assets/icon-calendar.svg";
// @ts-ignore
import ICON_CARET from "../../assets/icon-caret.svg";
import { DayPicker } from '../DayPicker'
import { SelectV2 } from '../SelectV2'
import { ISelect } from '../SelectV2/types'
import "./styles.scss";

export class Filters extends React.PureComponent<any, any> {
  /**
   * @name getParameters
   * @description
   * @author Jonathan IBOR
   * @static
   * @param {string} parameters
   * @returns
   * @memberof Filters
   */
  static getParameters(parameters: string) {
    const params = parameters?.split('?')[1]

    const separateEachFilters = params?.split('&')

    let arrayOfFilters: any = []

    separateEachFilters?.forEach((item) => {
      const getLabel = item.split('=')[0]
      const getValues: any = item
        .split('=')[1]
        ?.split(',')
        .map((el: any) => {
          if (Number(el)) {
            return Number(el)
          }

          return el
        })

      arrayOfFilters = [
        ...arrayOfFilters,
        {
          value: getValues,
          label: getLabel,
        },
      ]
        .filter(el => el.value !== undefined)
    })

    return arrayOfFilters
  }

  constructor(props: any) {
    super(props)

    this.state = {
      filters: {
        from: this.props?.globalDate?.from
          ? moment(this.props.globalDate.from).unix()
          : null,
        to:
          this.props?.globalDate?.to ? moment(this.props.globalDate.to).unix() :
          null,
      },
      columns: [],
      initialValues: {},
      from: null,
      to: null,
    };

    this.formattingFilters = this.formattingFilters.bind(this)
    this.generateAction = this.generateAction.bind(this)
    this.onHandleClose = this.onHandleClose.bind(this)
    this.onSelectStartDate = this.onSelectStartDate.bind(this)
    this.onSelectEndDate = this.onSelectEndDate.bind(this)
    this.setFiltersIntoUrl = this.setFiltersIntoUrl.bind(this)
    this.updateFiltersState = this.updateFiltersState.bind(this)
    this.isReset = this.isReset.bind(this)
  }

  /**
   * @name setFiltersIntoUrl
   * @description
   * @author Jonathan IBOR
   * @memberof Filters
   */
  setFiltersIntoUrl() {
    const { filters } = this.state
    let newFilters = ''

    Object.keys(filters).forEach((element: any) => {
      if (filters[element]?.value) {
        newFilters += `${element}=${filters[element].value?.join(',')}&`
      }

      if (typeof filters[element] === 'string' || typeof filters[element] === 'number') {
        if (filters[element].length !== 0) {
          newFilters += `${element}=${(filters[element])}&`
        }
      }

      if (Array.isArray(filters[element]) && filters[element][0]) {
        newFilters += `${element}=${filters[element]?.join(',')}&`
      }
    })

    this.props.history.push(`${this.props.path}?${newFilters.slice(0, -1)}`)
  }

  updateInitialValuesState({ item = {}, getValue = {}, filter = {}, updateInitialValues = {}, data, date = false }: any) {
    if (date) {
      return {
        ...this.state.initialValues,
        ...updateInitialValues,
        [item.label]: item,
      }
    }

    if (filter && filter?.isSelect) {
      return {
        ...this.state.initialValues,
        ...updateInitialValues,
        [item.label]: data,
      }
    }

    return {
      ...this.state.initialValues,
      ...updateInitialValues,
      [item.label]: getValue?.value?.join(','),
    }
  }

  updateFiltersState(item, getValue, updateFilters, date = false) {
    const data_key = this.props.CONFIG_FILTERS.find(el => el.key === item.label)

    const values = data_key && this.props[data_key?.data]?.map((el) => el.value) || []

    const filters = {
      ...this.state.filters,
    };

    if (date) {
      const filters = {
        ...this.state.filters,
      };
      this.props?.getFilters({
        ...this.state.filters,
        ...{
          ...this.state.filters,
          ...updateFilters,
          [item.label]: item,
        }
      })

      return {
        ...this.state.filters,
        ...updateFilters,
        [item.label]: item,
      }
    }

    if (data_key?.withSearch) {
      this.props?.getFilters({
        ...this.state.filters,
        ...{
          ...this.state.filters,
          ...updateFilters,
          [item.label]: getValue && getValue.value ? getValue.value : getValue,
        }
      })

      return {
        ...this.state.filters,
        ...updateFilters,
        [item.label]: getValue && getValue.value ? getValue.value : getValue,
      }
    }

    if (data_key && !data_key.isFilters && !values.includes(getValue.value[0].toString())) {

      return {
        ...this.state.filters,
        ...updateFilters,
      }
    }

    this.props?.getFilters({
      ...this.state.filters,
      ...{
        ...this.state.filters,
        ...updateFilters,
        [item.label]: getValue && getValue.value ? getValue.value : getValue,
      }
    })

    return {
      ...this.state.filters,
      ...updateFilters,
      [item.label]: getValue && getValue.value ? getValue.value : getValue,
    }
  }

  /**
   * @name componentDidMount
   * @description React Lifecycle
   * @author Jonathan IBOR
   * @memberof Filters
   */
  componentDidMount() {
    let updateInitialValues = {}
    let updateFilters = {}
    const { CONFIG_FILTERS } = this.props

    CONFIG_FILTERS.map(el => {
      if (el.action) {
        this.props.store.dispatch(el?.action({ page: 1, perPage: 50, name: '' }) as any)
      }
    })

    if (this.props.location?.search.length > 0) {
      const values = Filters.getParameters(this.props.location?.search) as ISelect[]
      const date = values.filter(elmt => (elmt.label === 'from' || elmt.label === 'to'))

      values?.forEach((item: any) => {
        if (Array.isArray(CONFIG_FILTERS)) {
          CONFIG_FILTERS.forEach(elmt => {
            if (elmt.key === item.label) {
              const filter = CONFIG_FILTERS?.find(elmt => elmt.key === item.label) || {}
              const getValue: any = filter ? values.find(el => el.label === filter.key) : {}
              let data = filter?.data && this.props[filter?.data as any]?.filter(elmt => getValue.value?.includes(elmt.value))

              if (filter?.action) {
                this.generateAction('', filter)
              }

              if (!filter?.multi) {
                data = filter?.data && [filter?.data && this.props[filter?.data as any]?.find(el => el.value === getValue.value?.[0].toString())]
              }

              updateInitialValues = this.updateInitialValuesState({ item, getValue, filter, updateInitialValues, data })
              updateFilters = this.updateFiltersState(item, getValue, updateFilters)
            }
          })
        }
      })

      if (!values.some(item => item.label === 'date')) {
        date.forEach((item: any) => {
          updateInitialValues = this.updateInitialValuesState({ item, date: true, updateInitialValues })
          updateFilters = this.updateFiltersState(item, null, updateFilters)
        })
      }

      if (values.some(item => item.label === 'date')) {
        const date = values.find(item => item.label === 'date')
        if (this.props.setPeriodWithMonthRange) {
          this.props.setPeriodWithMonthRange(date?.value[0])
        }
      } else {
        if (this.props.setPeriodWithMonthRange) {
          this.props.setPeriodWithMonthRange('DATEPICKER_FILTER_MONTH_TO_DATE')
        }
      }

      if (values.some((item) => item.label === "status")) {
        const status = values.find(
          (item) => item.label === "status"
        ) as any;

        updateFilters = {
          ...this.state.filters,
          ...updateFilters,
          [status.label]: status?.value[0],
        };

        updateInitialValues = {
          ...this.state.updateInitialValues,
          ...updateInitialValues,
          [status.label]: status,
        };
      }

      this.setState({
        initialValues: {
          ...this.state.initialValues,
          ...updateInitialValues,
        },
        filters: updateFilters,
      })

      if (this.props.getFilters) {
        this.props?.getFilters(updateFilters);
      }

      if (Array.isArray(updateFilters['from']?.value) && updateFilters['from']?.value[0]) {
        if (updateFilters['from']?.value) {
          this.props.setGlobalDate(moment.unix(updateFilters['from']?.value[0]), moment.unix(this.props.globalDate.to))
        }

        if (updateFilters['to']?.value) {
          this.props.setGlobalDate(moment.unix(this.props.globalDate.from), moment.unix(updateFilters['to']?.value[0]))
        }

        if (updateFilters['from']?.value && updateFilters['to']?.value) {
          this.props.setGlobalDate(moment.unix(updateFilters['from']?.value[0]), moment.unix(updateFilters['to']?.value[0]))
        }
      }
    }
  }

  /**
   * @name componentDidUpdate
   * @description React Lifecycle
   * @author Jonathan IBOR
   * @param {Props} nextProps
   * @param {State} nextState
   * @memberof Filters
   */
  componentDidUpdate(nextProps: any, nextState: any) {
    const { CONFIG_FILTERS } = this.props

    let updateInitialValues = {}
    let updateFilters = {}

    const values = Filters.getParameters(this.props.location?.search) as ISelect[]

    if (this.props.parent_filter !== nextProps.parent_filter) {
      const new_filters = {
        ...updateFilters,
        ...this.state.filters,
        ...this.props.parent_filter,
        name: this.props.name,
      }

      this.setState({
        filters: new_filters,
      })

      this.props.stopSetUrl && this.props.getFilters(new_filters)
    }

    if (
      Object.keys(this.state.initialValues)?.length !==
      Object.keys(nextState.initialValues)?.length
    ) {
      if (this.state.initialValues.status !== nextState.initialValues.status) {
        this.setFiltersIntoUrl();
      }

      if (this.state.initialValues?.from !== nextState.initialValues?.from) {
        this.setFiltersIntoUrl()
      }

      if (this.state.initialValues?.to !== nextState.initialValues?.to) {
        this.setFiltersIntoUrl();
      }
    }

    if (this.state.initialValues?.from !== nextState.initialValues?.from) {
      this.setState({
        from: this.state.initialValues?.from,
      });
    }

    if (this.state.initialValues?.to !== nextState.initialValues?.to) {
      this.setState({
        to: this.state.initialValues?.to,
      });
    }

    if (this.props.name !== nextProps.name) {
      this.setState({
        filters: {
          ...updateFilters,
          ...this.state.filters,
          ...this.props.parent_filter,
          name: this.props.name,
        },
      });
    }

    /* if (this.props.status !== nextProps.status) {
      this.setState({
        filters: {
          ...updateFilters,
          ...this.state.filters,
          ...this.props.parent_filter,
          status: this.props.status
        },
      });
    } */

    if (this.props.currentDatePattern !== nextProps.currentDatePattern) {
      const updateFilters = this.state.filters

      delete updateFilters['from']
      delete updateFilters['to']

      this.setState({
        filters: {
          ...updateFilters,
          date: [this.props.currentDatePattern],
        },
      })

      if (this.props.getFilters) {
        this.props?.getFilters({
          ...updateFilters,
          date: [this.props.currentDatePattern],
        });
      }
    }

    if (this.state.filters['date']) {
      this.state.filters['date'].forEach((element: any, index: number) => {
        if (element !== (Array.isArray(nextState.filters['date']) && nextState.filters['date'][index])) {
          !this.props.stopSetUrl && this.setFiltersIntoUrl()
          this.props.onGenerate(this.state.filters)
        }
      })
    }

    if (this.props.isReset !== nextProps.isReset) {
      if (this.props.isReset) {
        this.setState({
          filters: {},
          initialValues: {},
        })
      }

      return
    }

    values?.forEach((item: ISelect) => {
      if (Array.isArray(this.props.CONFIG_FILTERS)) {
        this.props.CONFIG_FILTERS.forEach((elmt: any) => {
          if (elmt.key === item.label) {
            const filter = CONFIG_FILTERS.find((elmt: any) => elmt.key === item.label)
            const getValue: any = values.find(
              (el: any) => el.label === filter?.key
            )

            let data = Array.isArray(this.props[filter?.data as any]) && this.props[filter?.data as any]?.filter((elmt: any) => getValue.value?.includes(elmt.value))

            if (!filter?.multi && !filter.isSelect) {
              data = Array.isArray(this.props[filter?.data as any]) &&
                [this.props[filter?.data as any]?.find((el: ISelect) => el.value === getValue.value?.[0].toString())]
            }

            if (this.props[filter?.data as any]?.length !== nextProps[filter?.data as any]?.length) {
              updateInitialValues = this.updateInitialValuesState({ item, getValue, filter, updateInitialValues, data })

              updateFilters = this.updateFiltersState(item, getValue, updateFilters)

              this.setState({
                initialValues: updateInitialValues,
                filters: updateFilters,
              })
            }
          }
        })
      }
    })

    if (!this.props.currentDatePattern) {
      let newFiltersDate = {}
      const updateFilters = this.state.filters

      if (this.props?.globalDate?.from !== nextProps?.globalDate?.from) {
        if (this.props?.globalDate?.from) {
          newFiltersDate = {
            from: moment(this.props.globalDate.from).unix(),
            to: moment(this.props.globalDate.to).unix(),
          }

          this.setState({
            filters: {
              ...this.state.filters,
              ...updateFilters,
              ...newFiltersDate,
            },
          })
        }

        // !this.props.stopSetUrl && this.setFiltersIntoUrl()
      }

      if (this.props?.globalDate?.to !== nextProps?.globalDate?.to) {
        if (this.props?.globalDate?.to) {
          newFiltersDate = {
            from: moment(this.props.globalDate.from).unix(),
            to: moment(this.props.globalDate.to).unix(),
          }

          this.setState({
            filters: {
              ...this.state.filters,
              ...updateFilters,
              ...newFiltersDate,
            },
          })
        }

        // !this.props.stopSetUrl && this.setFiltersIntoUrl()
      }
    }

    /* if (Object.entries(this.state.filters)?.length !== Object.entries(nextState.filters)?.length) {
      console.log("here 7 : ", this.state.filters);
      !this.props.stopSetUrl && this.setFiltersIntoUrl()
    } */

    if (Array.isArray(this.props.CONFIG_FILTERS)) {
      this.props.CONFIG_FILTERS.forEach((elmt: string) => {
        if (this.state.filters['date'] !== nextState.filters['date']) {
          if (this.state.filters['date']?.length !== nextState.filters['date']?.length) {
            !this.props.stopSetUrl && this.setFiltersIntoUrl()
          }
        }

        if (elmt === 'from') {
          if (this.state.filters[elmt] !== nextState.filters[elmt]) {
            !this.props.stopSetUrl && this.setFiltersIntoUrl()
          }
        }

        if (elmt === 'to') {
          if (this.state.filters[elmt] !== nextState.filters[elmt]) {
            !this.props.stopSetUrl && this.setFiltersIntoUrl()
          }
        }
      })
    }

    if (this.props.autoReload) {
      Object.keys(this.state.filters).forEach(item => {
        if (!Array.isArray(this.state.filters[item])) {
          if (this.state.filters[item] !== nextState.filters[item]) {
            this.props.onGenerate(this.state.filters)
          }
        }

        if (Array.isArray(this.state.filters[item])) {
          if (this.state.filters[item]?.length !== nextState.filters[item]?.length) {
            this.props.onGenerate(this.state.filters)
          }
        }
      })
    }

    Object.keys(this.state.filters).forEach((item) => {
      if (Array.isArray(this.state.filters[item])) {
        if (
          this.state.filters[item]?.length !== nextState.filters[item]?.length
        ) {
          this.setFiltersIntoUrl();
        }
      }
      if (this.state.filters[item] !== nextState.filters[item]) {
        this.setFiltersIntoUrl();
      }
    });
  }

  /**
   * @name formattingFilters
   * @description
   * @author Jonathan IBOR
   * @param {(ISelect[] | string)} value
   * @param {*} item
   * @returns
   * @memberof Filters
  */
  formattingFilters(value: ISelect[] | string | any, item: any) {
    if (item.isSelect) {
      if (Array.isArray(value) && value?.length > 0) {
        this.setState({
          filters: {
            ...this.state.filters,
            [item.key]: value.map((el: ISelect) => el.value),
          },
        })

        if (this.props.getFilters) {
          this.props?.getFilters({
            ...this.state.filters,
            [item.key]: value.map((el: ISelect) => el.value),
          });
        }
      }

      return
    }

    if (typeof value === 'string') {
      const updateFilters = {
        ...this.state.filters,
        [item.key]: value,
      }

      this.setState({
        filters: updateFilters,
      })

      if (this.props.getFilters) {
        this.props?.getFilters(updateFilters);
      }
    }
  }

  /**
   * @description
   * @author Jonathan IBOR
   * @param {Date} value
   * @memberof Filters
   */
  onSelectStartDate(value: Date): void {
    let updateFilters = {}
    const params = Filters.getParameters(this.props.location.search)
      .filter((item: ISelect) => item.label !== 'date')

    const from = moment(value).toDate()
    this.props.setGlobalDate(from, this.props.globalDate.to)

    params.forEach((item: ISelect) => {
      updateFilters = {
        ...updateFilters,
        [item.label]: item.value,
      }
    })

    this.setState({
      from, filters: {
        ...updateFilters,
        from: moment(from).unix(),
      },
    })
  }

  /**
   * @name onSelectEndDate
   * @description
   * @author Jonathan IBOR
   * @param {Date} value
   * @memberof Filters
  */
  onSelectEndDate(value: Date): void {
    let updateFilters = {}
    const params = Filters.getParameters(this.props.location.search)
      .filter((item: ISelect) => item.label !== 'date')

    const to = moment(value).set({ hour: 23, minute: 59, second: 59 }).toDate()
    this.props.setGlobalDate(this.props.globalDate.from, to)

    params.forEach((item: ISelect) => {
      updateFilters = {
        ...updateFilters,
        [item.label]: item.value,
      }
    })

    this.setState({
      to, filters: {
        ...updateFilters,
        to: moment(to).unix(),
      },
    })
  }

  /**
   * @name generateAction
   * @description
   * @author Jonathan IBOR
   * @param {*} value
   * @param {*} item
   * @returns
   * @memberof Filters
   */
  generateAction(value = '', item: any) {
    if (item.action) {
      this.props.store.dispatch(item?.action({ page: 1, perPage: 1000, name: value }) as any)
    }
  }

  /**
   * @name onHandleClose
   * @description
   * @author Jonathan IBOR
   * @param {*} item
   * @memberof Filters
   */
  onHandleClose(item: any) {
    const updateFilters = this.state.filters

    delete updateFilters[item.key]

    let newFilters = ''

    Object.keys(updateFilters).forEach((element) => {
      if (updateFilters[element]?.value) {
        newFilters += `${element}=${updateFilters[element].value?.join(',')}&`
      }

      if (typeof updateFilters[element] === 'string') {
        newFilters += `${element}=${(updateFilters[element])}&`
      }

      if (typeof updateFilters[element] === 'number') {
        newFilters += `${element}=${(updateFilters[element])}&`
      }

      if (Array.isArray(updateFilters[element])) {
        newFilters += `${element}=${updateFilters[element]?.join(',')}&`
      }
    })

    this.setState({ filters: updateFilters })

    if (this.props.getFilters) {
      this.props?.getFilters(updateFilters);
    }

    if (this.props.onGenerate) {
      this.props.onGenerate(updateFilters)
    }

    this.props.history.push(`${this.props.path}?${newFilters}`)
  }

  isReset(item: any) {
    const values = Filters.getParameters(this.props.location?.search) as ISelect[]

    if (values.some(elmt => elmt.label === item.key)) {
      return false
    }

    return true
  }

  componentWillUnmount() {
    this.setState({
      filters: {},
      columns: [],
      initialValues: {},
      from: null,
      to: null,
    })
  }

  render() {
    const { t, CONFIG_FILTERS, globalDate, filters } = this.props

    return (
      <React.Fragment>
        {globalDate?.from && (
          <div className="mr-10 mb-30">
            <DayPicker
              formatDate={formatDate}
              parseDate={parseDate}
              dayPickerProps={{
                locale: "fr",
                localeUtils: MomentLocaleUtils,
              }}
              label="Du"
              placeholder="Selectionner un jour..."
              initialValue={
                this.state.initialValues?.from?.value[0]
              }
              selectedDay={(day: Date) => this.onSelectStartDate(day)}
              icon={<SVG src={FormatText.formatSVGBase64(ICON_CALENDAR)} />}
            />
          </div>
        )}
        {globalDate?.to && (
          <div className="mr-10 mb-30">
            <DayPicker
              formatDate={formatDate}
              parseDate={parseDate}
              dayPickerProps={{
                locale: "fr",
                localeUtils: MomentLocaleUtils,
              }}
              label="Au"
              placeholder="Selectionner un jour..."
              initialValue={
                this.state.initialValues?.to?.value[0]
              }
              selectedDay={(day: Date) => this.onSelectEndDate(day)}
              icon={<SVG src={FormatText.formatSVGBase64(ICON_CALENDAR)} />}
            />
          </div>
        )}
        {CONFIG_FILTERS?.map((item: any, i: number) => {
          if (item.isFilters) {
            return (
              <div key={i} className="mr-10 mb-30">
                <SelectV2
                  type={!item.isSelect ? "text" : ""}
                  label={t && t(`filters.${item.label}`)}
                  placeholder={t && t(`filters.${item.label}`)}
                  data={this.props[item.data] ? this.props[item.data] : null}
                  getElements={(value: any) =>
                    this.formattingFilters(value, item)
                  }
                  onHandleReset={() => this.onHandleClose(item)}
                  handleBlur={() => {}}
                  handleFocus={() => {}}
                  action={(value: any) => this.generateAction(value, item)}
                  initialValues={this.state.initialValues[item?.key] || null}
                  reset={this.isReset(item)}
                  isFocus={this.props[item.data]?.length > 0 ? true : false}
                  isSelected={
                    Object.keys(filters)?.find(
                      (key: string) => key === this.props[item.key]
                    )
                      ? true
                      : false
                  }
                  icon={
                    ICON_CARET ? (
                      <SVG src={FormatText.formatSVGBase64(ICON_CARET)} />
                    ) : (
                      ""
                    )
                  }
                  multi={item.multi || false}
                />
              </div>
            );
          }
        })}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any) => {
  let stateProps = {};

  if (state) {
    let {
      datepicker: { globalDate },
      reporting: { filters },
      user,
    } = stateProps;
  }

  return {
    user,
    globalDate: {
      from: 1622534590,
      to: 1625040190,
    },
    filters,
  };
}

export default compose<any>(
  withRouter,
  connect(mapStateToProps),
)(Filters)
